import { fabric } from 'fabric';
import { ReactNode, useEffect, useState } from 'react';

import { SlabImgContext } from './slabImg.context';
import { type SlabImgContextType } from './slabImg.types';

import { getBase64FromURL, imgUrl } from '~/core/utils';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedColor } from '~/redux/slices/color';

export const SlabImgProvider = ({
  children,
}: {
  children?: ReactNode;
}): JSX.Element => {
  const selectedColor = useAppSelector(selectSelectedColor);
  const [slabImg, setSlabImg] = useState<SlabImgContextType>({
    element: new Image(),
    url: '',
  });

  const getBase64ImageAndLoadInFabric = async (imageUrl = '') => {
    const slabImageUrl = imageUrl
      ? imgUrl(imageUrl.replace('-thumbnail', ''), 2400)
      : '/public/mock/images/white.jpg';

    try {
      const slabImageUrlInBase64 = await getBase64FromURL(slabImageUrl);

      fabric.util.loadImage(slabImageUrlInBase64, (element) => {
        if (slabImageUrl && element) {
          setSlabImg({ url: imageUrl, element });
        }
      });
    } catch (error) {
      // TODO: find a better way to handle image loading errors
      console.error(error);
    }
  };

  useEffect(() => {
    if (
      selectedColor?.slabImageUrl &&
      (!slabImg.url || slabImg.url !== selectedColor?.slabImageUrl)
    ) {
      getBase64ImageAndLoadInFabric(selectedColor?.slabImageUrl);
    }
  }, [selectedColor?.slabImageUrl, slabImg.url]);

  return (
    <SlabImgContext.Provider value={slabImg}>
      {children}
    </SlabImgContext.Provider>
  );
};
